import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Typography } from 'ha/ui/next/Typography';
import Grid from 'ha/ui/next/Grid';
import { useIntl } from 'ha/i18n';

import {
  TypeFilterValue,
  RoomsFilterValue,
  TypeValue,
  RoomsValue,
} from 'ha/types/SearchFilters';
import FilterCheckbox from './FilterCheckbox';
import RoomsFilter from './RoomsFilter';

interface Props {
  types: TypeFilterValue;
  rooms: RoomsFilterValue;
  onToggle: (type: TypeValue, selected: boolean) => void;
  onRoomsFilterChange: (type: RoomsValue, selected: boolean) => void;
}

const useStyles = makeStyles(theme => ({
  roomsFilter: {
    marginLeft: theme.spacing(4),
  },
}));

export const TypeFilter: React.FC<Props> = ({
  types,
  rooms,
  onToggle,
  onRoomsFilterChange,
}) => {
  const { T } = useIntl();
  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography.ParagraphTitle data-test-locator="TypeFilter Title">
        {T('Property type')}
      </Typography.ParagraphTitle>

      <Grid container>
        <Grid item>
          <FilterCheckbox
            name={`${TypeValue.APARTMENT}-checkbox`}
            isActive={types.includes(TypeValue.APARTMENT)}
            onToggle={(selected: boolean) =>
              onToggle(TypeValue.APARTMENT, selected)
            }
            data-test-locator="TypeFilter Apartment"
          >
            <Typography.Paragraph noWrap>{T('Apartment')}</Typography.Paragraph>
          </FilterCheckbox>
          <div className={classes.roomsFilter}>
            <RoomsFilter rooms={rooms} onChange={onRoomsFilterChange} />
          </div>
          <FilterCheckbox
            name={`${TypeValue.PRIVATE_ROOM}-checkbox`}
            isActive={types.includes(TypeValue.PRIVATE_ROOM)}
            onToggle={(selected: boolean) =>
              onToggle(TypeValue.PRIVATE_ROOM, selected)
            }
            data-test-locator="TypeFilter PrivateRoom"
          >
            <Typography.Paragraph noWrap>
              {T('Private Room')}
            </Typography.Paragraph>
          </FilterCheckbox>
          <FilterCheckbox
            name={`${TypeValue.SHARED_ROOM}-checkbox`}
            isActive={types.includes(TypeValue.SHARED_ROOM)}
            onToggle={(selected: boolean) =>
              onToggle(TypeValue.SHARED_ROOM, selected)
            }
            data-test-locator="TypeFilter SharedRoom"
          >
            <Typography.Paragraph noWrap>
              {T('Shared Room')}
            </Typography.Paragraph>
          </FilterCheckbox>
          <FilterCheckbox
            name={`${TypeValue.STUDIO}-checkbox`}
            isActive={types.includes(TypeValue.STUDIO)}
            onToggle={(selected: boolean) =>
              onToggle(TypeValue.STUDIO, selected)
            }
            data-test-locator="TypeFilter Studio"
          >
            <Typography.Paragraph noWrap>{T('Studio')}</Typography.Paragraph>
          </FilterCheckbox>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default TypeFilter;
